import { Route, Routes, useNavigate } from "react-router-dom"
import { ConfigProvider } from "antd"
import LayoutComponent from "../pages/main/layout";
import Lawyer from "../pages/main/lawyer";
import Login from "../pages/Login";
import Requests from "../pages/main/Ruquest";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getconfigList } from "../reducer/config.reducer";
import Compliant from "../pages/main/compliant";
import Customer from "../pages/main/customer";
import Support from "../pages/main/support";
import ConsultationMonitoring from "../pages/main/consultation";
import Config from "../pages/main/config";
import Transactions from "../pages/main/transactions";
import Dashboard from "../pages/main/dashboard";
import Coupon from "../pages/main/coupon";
import Penalty from "../pages/main/penalty"
import AccessController from "../pages/main/accesscontroller";
import User from "../pages/main/user";
import GstInvoice from "../pages/main/gstInvoice";

const RouterNavigation = () => {
    const authenticatesUser = sessionStorage.getItem("_ac");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(()=>{
        if(authenticatesUser){
            dispatch(getconfigList());
        }
    },[authenticatesUser,dispatch]);

    useEffect(()=>{
        const isAuthenticated = Boolean(authenticatesUser);
         if (!isAuthenticated && window?.location?.pathname !== "/") {
            navigate("/");
        }
         if (window?.location?.pathname === "/") {
            navigate(window?.location?.pathname, { replace: true });
        }
    },[authenticatesUser,navigate]);

    return <div>
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: "#AD8D45",
                    colorTextSecondary: "#333",
                    colorLink: "#AD8D45",
                    fontFamily: "'Roboto', sans-serif",
                    colorLinkHover: "#AD8D45",
                    fontSizeLG: "16px",
                    fontSizeHeading2: "26px",
                    colorTextPlaceholder: "#9996A0",
                    colorBorder: "lightgrey",
                },
            }}
        >
            <Routes>
                {
                    authenticatesUser ?<>
                    <Route path="/" element={<LayoutComponent />}>
                        <Route path="/Dashboard" element={<Dashboard/>}></Route>
                        <Route path="/Lawyer" element={<Lawyer/>}></Route>
                        <Route path="/Advocate" element={<Lawyer/>}></Route>
                        <Route path="/Requests" element={<Requests/>}></Route>
                        <Route path="/Complaints" element={<Compliant/>}></Route>
                        <Route path="/Customer"element={<Customer/>}></Route>
                        <Route path="/Support" element={<Support/>}></Route>
                        <Route path="/Consultations" element={<ConsultationMonitoring/>}></Route>
                        <Route path="/Transactions" element={<Transactions/>}></Route>
                        <Route path="/GstInvoice" element={<GstInvoice/>}></Route>
                        <Route path="/Penalty" element={<Penalty/>}></Route>
                        <Route path="/Coupon" element={<Coupon/>}></Route>
                        <Route path="/Config" element={<Config/>}></Route>
                        <Route path="/AccessController" element={<AccessController/>}></Route>
                        <Route path="/User" element={<User/>}></Route>
                     </Route>
                    </>:<>
                     <Route path="/" element={<Login />} />
                    </>
                }
            </Routes>
        </ConfigProvider>
    </div>
}
export default RouterNavigation